import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const Element451ReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="element451ReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />

      <FormField
        controlId="element451ReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />

      <FormField
        controlId="element451ReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="element451ReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.parameterizedBy?.message}
      />

      <FormField
        controlId="element451ReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.format?.message}
      />

      <FormField
        controlId="element451ReaderFormClient"
        label="client"
        name="properties.client"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.client?.message}
      />

      <FormField
        controlId="element451ReaderFormApi"
        label="api"
        name="properties.api"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.api?.message}
      />

      <FormField
        controlId="element451ReaderFormTaskGUID"
        label="taskGUID"
        name="properties.taskGUID"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.taskGUID?.message}
      />

      <FormField
        controlId="element451ReaderFormFeature"
        label="feature"
        name="properties.feature"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.feature?.message}
      />

      <FormField
        controlId="element451ReaderFormPerPage"
        label="perPage"
        name="properties.perPage"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors.properties?.perPage?.message}
      />

      <FormField
        controlId="element451ReaderFormShowSchema"
        label="showSchema"
        name="properties.showSchema"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="element451ReaderFormIsRetry"
        label="isRetry"
        name="properties.isRetry"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="element451ReaderFormSleepInMilliSeconds"
        label="sleepInMilliSeconds"
        name="properties.sleepInMilliSeconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors.properties?.sleepInMilliSeconds?.message}
      />

      <FormField
        controlId="element451ReaderFormRetryCount"
        label="retryCount"
        name="properties.retryCount"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors.properties?.retryCount?.message}
      />

      <SchemaEditor form={form} id={id} />

      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default Element451ReaderForm;
